<template>
    <section class="def-slider">
        <div class="def-slider__container">
            <div
                v-if="nav"
                ref="prev"
                class="def-slider__nav def-slider__prev"
            >
                <slot name="nav-prev">
                <span class="def-slider__default-button">
                    <svg><use xlink:href="#svg-arrow-left"></use></svg>
                </span>
                </slot>
            </div>
            <div ref="slider" class="swiper-container">
                <div class="swiper-wrapper">
                    <slot />
                </div>
            </div>
            <div
                v-if="nav"
                ref="next"
                class="def-slider__nav def-slider__next"
            >
                <slot name="nav-next">
                <span class="def-slider__default-button">
                    <svg><use xlink:href="#svg-arrow-right"></use></svg>
                </span>
                </slot>
            </div>
        </div>
        <!-- If we need scrollbar -->
        <div v-if="scrollbar" ref="scrollbar" class="swiper-scrollbar"></div>
        <!-- If we need pagination -->
        <div
            v-if="pagination"
            ref="pagination"
            class="swiper-pagination"
            :class="{ 'def-slider__pagination': $slots.default && $slots.default.length > 1 }"
        ></div>
    </section>
</template>

<script>
export default {
    name: 'DefSlider',
    props: ['settings', 'scrollbar', 'nav', 'pagination'],
    data() {
        return {
            slider: null,
            activeIndex: 0,
            slidesCount: 0,
        }
    },
    methods: {
        createSlider() {
            this.slider = new Swiper(this.$refs.slider,  {
                navigation: {
                    nextEl: this.$refs.next,
                    prevEl: this.$refs.prev,
                },
                pagination: {
                    el: this.$refs.pagination,
                    clickable: true,
                },
                scrollbar: {
                    el: this.$refs.scrollbar,
                    draggable: true,
                },
                ...this.settings,
            });

            this.slider.on('slideChange', ({ activeIndex }) => this.activeIndex = activeIndex);
            this.activeIndex = this.slider?.activeIndex;
            this.slidesCount = this.slider?.slides?.length;
        },
    },
    updated() {
        this.slider.update(true);
    },
    mounted() {
        this.createSlider();
    },
    beforeUnmount() {
        this.slider.destroy();
    }
}
</script>

<style lang="scss" scoped>
.def-slider{
    &__container{
        position: relative;
        margin-bottom: 24px;
    }
    &__nav{
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        cursor: pointer;

        -webkit-user-select: all;  /* Chrome 49+ */
        -moz-user-select: all;     /* Firefox 43+ */
        -ms-user-select: all;      /* No support yet */
        user-select: all;          /* Likely future */

        &_disabled{
            display: none;
        }
    }
    &__next{
        right: 68px;
    }
    &__prev{
        left: 68px;
    }
    &__default-button{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        /*background: #F6F6F6;*/
        svg{
            display: block;
            /*width: 30px;*/
            /*height: 30px;*/
            /*fill: #000;*/
        }
    }
    &__pagination{
        margin-top: 16px;
        @include point-md{
            margin-top: 24px;
        }
    }
    .swiper-scrollbar{
        background: #F2F2F2;
        width: 100%;
        border-radius: 4px;
        height: 8px;
        position: static;
        margin-top: 16px;
    }
    .swiper-scrollbar-drag{
        background-color: var(--color-red);
        border-radius: 4px;
    }
    .swiper-slide{
        height: unset;
    }
    .swiper-wrapper{
        align-self: stretch;
        width: 100%;
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        position: relative;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        z-index: 1;
    }
    :deep(.swiper-pagination-bullet){
        width: 8px;
        height: 8px;
        background-color: var(--background-black);
        opacity: 0.2;
        transition: .2s linear opacity;
        margin-bottom: 12px;
        margin-left: 0;
        &:not(:last-child) {
            margin-right: 12px;
        }
    }
    :deep(.swiper-pagination-bullet-active){
        opacity: 1;
    }
    :deep(.swiper-container){
        overflow: hidden;
    }
    :deep(.swiper-button-disabled) {
        display: none;
    }
}

.smollBasket {
  .buy-complect-slider {
    .def-slider__container {
      margin-bottom: 0;
    }
  }
}
.buy-complect-slider {
  .def-slider__next {
    right: 0;
  }
  .def-slider__prev {
    left: 0;
  }
}

</style>